import * as moment from 'moment-timezone';

const PAKISTAN_TIME_ZONE = 'Asia/Karachi';

export class AppConstant {
  static getUserTimeZoneWithCompanyWise(timeZoneName: string) {
    const timeZoneMapping: { [key: string]: string } = {
      Riyadh: PAKISTAN_TIME_ZONE,
      Dubai: PAKISTAN_TIME_ZONE,
      Karachi: PAKISTAN_TIME_ZONE
    };

    const timeZone = timeZoneMapping[timeZoneName] || PAKISTAN_TIME_ZONE;
    return moment().tz(timeZone).format('MM-DD-YYYY HH:mm:ss');
  }

  static getUserTimeZoneWithId(timeZoneId: number) {
    return moment().tz(PAKISTAN_TIME_ZONE).format('MM-DD-YYYY HH:mm:ss');
  }

  static getUserDateConvert(timeZoneId: number, date: string) {
    return moment(date).tz(PAKISTAN_TIME_ZONE).format('MM-DD-YYYY HH:mm:ss');
  }
  static getDate() {
    return moment().tz(PAKISTAN_TIME_ZONE).format('MM-DD-YYYY HH:mm:ss');
  }
  static getUserId() {
    return JSON.parse(localStorage.getItem("user")).userId;
  }

  static getAccountId() {
    return JSON.parse(localStorage.getItem("user")).accountId;
  }

  static getOnlyDate(date: Date): string {
    return moment(date).format('DD/MMM/yyyy');
  }

  static getDateGMT(): string {
    // Get current date and time
    var currentDate = new Date();

    // Get GMT offset in minutes (e.g., -300 for GMT+5:00)
    var gmtOffsetInMinutes = Math.abs(new Date().getTimezoneOffset());

    // Calculate the GMT offset in milliseconds
    var gmtOffsetInMilliseconds = gmtOffsetInMinutes * 60 * 1000;

    // Create a new Date object with the GMT offset
    var dateWithOffset = new Date(currentDate.getTime() + gmtOffsetInMilliseconds);
    return dateWithOffset.toJSON();
  }

  static getDateGMTInput(year: number, month: number, day: number): string {
    // Get current date and time
    var currentDate = new Date(year, month, day);

    // Get GMT offset in minutes (e.g., -300 for GMT+5:00)
    var gmtOffsetInMinutes = Math.abs(new Date().getTimezoneOffset());

    // Calculate the GMT offset in milliseconds
    var gmtOffsetInMilliseconds = gmtOffsetInMinutes * 60 * 1000;

    // Create a new Date object with the GMT offset
    var dateWithOffset = new Date(currentDate.getTime() + gmtOffsetInMilliseconds);
    return dateWithOffset.toJSON();
  }

  static getKSADateGMT(): string {
    // Import moment-timezone library

    // Get the user's time zone
    const userTimeZone = moment.tz.guess();

    // Check if the user's time zone is 'Asia/Karachi'
    if (userTimeZone === PAKISTAN_TIME_ZONE) {
      // Return the current date and time without any conversion
      return new Date().toISOString();
    } else {
      // Convert the current date and time to 'Asia/Karachi' time zone
      // Get current date and time
      var currentDate = new Date();

      // Get GMT offset in minutes (e.g., -300 for GMT+5:00)
      var gmtOffsetInMinutes = Math.abs(new Date().getTimezoneOffset());

      // Calculate the GMT offset in milliseconds
      var gmtOffsetInMilliseconds = gmtOffsetInMinutes * 60 * 1000;

      // Create a new Date object with the GMT offset
      var dateWithOffset = new Date(currentDate.getTime() + gmtOffsetInMilliseconds);
      return dateWithOffset.toJSON();
    }
  }

  static ksaDefaultDate() {
    const utcDate = new Date();
    const saudiTime = moment(utcDate).tz(PAKISTAN_TIME_ZONE).format('YYYY-MM-DDTHH:mm:ss');
    return saudiTime;
  }
  static ksaSettDate(date: string) {
    const saudiTime = moment(date).tz(PAKISTAN_TIME_ZONE).format('YYYY-MM-DDTHH:mm:ss');
    return saudiTime;
  }

  /**
   * Get the decimal count value from the user object stored in local storage.
   *
   * @return {number} The decimal count value.
   */
  static getUserDecimalCount() {
        return 2;
    // If in future you want to make this dynamic again,
    // restore the previous logic here and all consumers that rely
    // on AppConstant formatting helpers will automatically follow it.
  }

  /**
   * Returns a DevExtreme compatible custom numeric format string
   * using the provided decimal count (or the user default when omitted).
   *
   * Examples:
   *  - decimalCount = 0  -> "#,##0"
   *  - decimalCount = 2  -> "#,##0.00"
   */
  static getDecimalFormatString(decimalCount?: number): string {
    const decimals = (typeof decimalCount === 'number' && decimalCount >= 0)
      ? decimalCount
      : AppConstant.getUserDecimalCount();

    if (!decimals) {
      return '#,##0';
    }

    return '#,##0.' + '0'.repeat(decimals);
  }

  /**
   * Returns a DevExtreme "fixedPoint" format configuration object
   * which can be bound directly to [format] on grid columns.
   */
  static getFixedPointFormat(decimalCount?: number) {
    const precision = (typeof decimalCount === 'number' && decimalCount >= 0)
      ? decimalCount
      : AppConstant.getUserDecimalCount();

    return {
      useGrouping: true,
      type: 'fixedPoint',
      precision
    };
  }

  /**
   * Formats a number to the configured decimal count.
   * Useful when you need a string (for example, before sending to APIs).
   */
  static formatNumberToUserDecimals(value: number | string | null | undefined, decimalCount?: number): string {
    const decimals = (typeof decimalCount === 'number' && decimalCount >= 0)
      ? decimalCount
      : AppConstant.getUserDecimalCount();

    const num = Number(value);
    if (isNaN(num)) {
      return '';
    }

    return num.toFixed(decimals);
  }
  static getUserDecimalPlace() {
    if (localStorage.getItem("selectedCompanyBranch")) {
      return JSON.parse(localStorage.getItem("selectedCompanyBranch")).decimalPlace;
    }
  }
}

